import LandingPageCards from '@/app/components/LandingPage/LandingPageCards';

import { cards } from './data/cards';

const BusinessCards = () => {
  return (
    <section className="pb-20" data-cy="business-cards">
      <LandingPageCards cards={cards} />
    </section>
  );
};

export default BusinessCards;
